export default __webpack_public_path__ + "static/screenSixthSectionUkBig-1aeff2fe6c0e5d9213ce7d2c8a5e482e.webp";